// ES2015 module syntax
import React from "react";
import { Chat } from "@progress/kendo-react-conversational-ui";
import PropTypes from "prop-types";

import "./Conversational.scss";

const ConversationalComponent = (props) => {
  const {
    user,
    messages,
    placeholder = "Nová správa",
    onSend,
    width = "80%",
  } = props;
  
  return (
    <React.Fragment>
      <Chat
        user={user}
        messages={messages}
        onMessageSend={onSend}
        placeholder={placeholder}
        width={width}
      />
    </React.Fragment>
  );
};

ConversationalComponent.propTypes = {
  user: PropTypes.object.isRequired,
  onSend: PropTypes.func.isRequired,
  messages: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  width: PropTypes.number,
};

export default ConversationalComponent;
